import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3523e374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.linkedin.com/in/brenda-cayzac-138297103/" }, "LinkedIn", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " Icons by Font Awesome. Roboto provided by Google Fonts. Web designed by Brenda Cayzac. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("nav", null, [
      ($setup.route.name !== 'home')
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.links, (link, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: link.icon
                }, null, 8, ["icon"]),
                _hoisted_2
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3
  ]))
}